var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#009cde;}.cls-3{fill:#0a74b9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Web_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_1336",
    "data-name": "Ellisse 1336"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37,
    cy: 37,
    r: 35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37,74A37,37,0,1,1,74,37,37,37,0,0,1,37,74ZM37,4A33,33,0,1,0,70,37,33,33,0,0,0,37,4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3199",
    "data-name": "Raggruppa 3199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_1332-5",
    "data-name": "Ellisse 1332-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.19,59.35A22.36,22.36,0,1,1,59.56,37,22.38,22.38,0,0,1,37.19,59.35Zm0-42A19.67,19.67,0,1,0,56.86,37,19.69,19.69,0,0,0,37.19,17.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_2268-5",
    "data-name": "Tracciato 2268-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.53,53.22a30.58,30.58,0,0,0-14-3.84,30.62,30.62,0,0,0-14,3.84l-1.26-2.38A33.32,33.32,0,0,1,37.5,46.69a33.36,33.36,0,0,1,15.3,4.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_2269-5",
    "data-name": "Tracciato 2269-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.5,27.3a33.15,33.15,0,0,1-15.29-4.16l1.27-2.37a30.54,30.54,0,0,0,14,3.83,30.59,30.59,0,0,0,14-3.83l1.27,2.37A33.23,33.23,0,0,1,37.5,27.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_1333-5",
    "data-name": "Ellisse 1333-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.21,59.36c-5.62,0-9.86-9.61-9.86-22.36s4.24-22.36,9.86-22.36S47.06,24.25,47.06,37,42.82,59.36,37.21,59.36Zm0-42c-3.39,0-7.16,8.08-7.16,19.67s3.77,19.67,7.16,19.67S44.37,48.59,44.37,37,40.59,17.33,37.21,17.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Linea_77-5",
    "data-name": "Linea 77-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.86,
    y: 35.38,
    width: 30.69,
    height: 2.69
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.94bfff9e9b26f8d3f370590197e647ed.svg";
export { ForwardRef as ReactComponent };